<template>
  <v-container class=" tw-flex tw-flex-col tw-gap-4" fluid>
    <div
      class=" tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2 lg:tw-grid-cols-3"
    >
      <!-- :class="$vuetify.breakpoint.mdAndUp ? '' : 'justify-center'" -->
      <v-card
        v-for="card in cards"
        :key="card.name"
        class=""
        :min-width="282"
        flat
        :to="card.to"
      >
        <div class="pa-5 tw-flex tw-w-full tw-justify-between tw-items-center">
          <div class="">
            <v-icon color="primary" class="" size="58">
              {{ card.iconName }}
            </v-icon>
          </div>
          <div class="text-end text-no-wrap tw-flex tw-flex-col tw-gap-2">
            <h2 class="py-0 my-0 tw-text-xl custom-font">
              {{ $t(card.name) }}
            </h2>
            <h2 class="py-0 my-0 primary--text custom-font">
              {{ card.count }}
            </h2>
          </div>
        </div>
      </v-card>
    </div>
    <v-row>
      <v-col cols="12" md="6" lg="6" sm="12">
        <v-card min-height="120" flat class="">
          <v-card-title class="mx-3 primary--text font-weight-black ma-0 pa-1">
            {{ $t("dashboard.active") }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row align="center">
              <v-col
                class="py-3"
                cols="12"
                md="4"
                lg="4"
                sm="4"
                xs="6"
                align="center"
              >
                <v-row>
                  <v-col cols="3" class="text-end">
                    <v-icon class="primary--text text-h4">mdi-account</v-icon>
                  </v-col>
                  <v-col cols="9">
                    <span class="grey1--text font-weight-bold">{{
                      $t("layout.user")
                    }}</span>
                    <p class="py-0 my-0 grey1--text font-weight-medium ">
                      {{ adminDashbordData.activeCustomers || 0 }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                class="py-3"
                cols="12"
                md="4"
                lg="4"
                sm="4"
                xs="6"
                align="center"
              >
                <v-row>
                  <v-col cols="3" class="text-end">
                    <v-icon class="primary--text text-h4"
                      >mdi-account-tie</v-icon
                    >
                  </v-col>
                  <v-col cols="9">
                    <span class="grey1--text font-weight-bold">{{
                      $t("layout.landlord")
                    }}</span>
                    <p class="py-0 my-0 grey1--text font-weight-medium ">
                      {{ adminDashbordData.activeLandlords || 0 }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                class="py-3"
                cols="12"
                md="4"
                lg="4"
                sm="4"
                xs="6"
                align="center"
              >
                <v-row>
                  <v-col cols="3" class="text-end">
                    <v-icon class="primary--text text-h4"
                      >mdi-city-variant</v-icon
                    >
                  </v-col>
                  <v-col cols="9">
                    <span class="grey1--text font-weight-bold">{{
                      $t("layout.properties")
                    }}</span>
                    <p class="py-0 my-0 grey1--text font-weight-medium ">
                      {{ adminDashbordData.activeProperties || 0 }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="6" sm="12">
        <v-card min-height="120" flat>
          <v-card-title class="mx-3 primary--text font-weight-black ma-0 pa-1">
            {{ $t("dashboard.inActive") }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row align="center">
              <v-col
                class="py-3"
                cols="12"
                md="4"
                lg="4"
                sm="4"
                xs="6"
                align="center"
              >
                <v-row>
                  <v-col cols="3" class="text-end">
                    <v-icon class="primary--text text-h4">mdi-account</v-icon>
                  </v-col>
                  <v-col cols="9">
                    <span class="grey1--text font-weight-bold">{{
                      $t("layout.user")
                    }}</span>
                    <p class="py-0 my-0 grey1--text font-weight-medium ">
                      {{ adminDashbordData.disabledCustomers || 0 }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                class="py-3"
                cols="12"
                md="4"
                lg="4"
                sm="4"
                xs="6"
                align="center"
              >
                <v-row>
                  <v-col cols="3" class="text-end">
                    <v-icon class="primary--text text-h4"
                      >mdi-account-tie</v-icon
                    >
                  </v-col>
                  <v-col cols="9">
                    <span class="grey1--text font-weight-bold">{{
                      $t("layout.landlord")
                    }}</span>
                    <p class="py-0 my-0 grey1--text font-weight-medium ">
                      {{ adminDashbordData.disabledLandlords || 0 }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                class="py-3"
                cols="12"
                md="4"
                lg="4"
                sm="4"
                xs="6"
                align="center"
              >
                <v-row>
                  <v-col cols="3" class="text-end">
                    <v-icon class="primary--text text-h4"
                      >mdi-city-variant</v-icon
                    >
                  </v-col>
                  <v-col cols="9">
                    <span class="grey1--text font-weight-bold">{{
                      $t("layout.properties")
                    }}</span>
                    <p class="py-0 my-0 grey1--text font-weight-medium ">
                      {{ adminDashbordData.disabledProperties || 0 }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      adminDashbordData: {},
      // items: [
      //   {
      //     title: 'dashboard.active',
      //     value: 'Active'
      //   },
      //   {
      //     title: 'dashboard.inActive',
      //     value: 'In Active'
      //   },
      //   {
      //     title: 'dashboard.total',
      //     value: 'Total'
      //   }
      // ],
      cards: [
        {
          iconName: "mdi-account",
          name: "layout.user",
          count: 0,
          //to: "/customer"
        },
        {
          iconName: "mdi-account-tie",
          name: "layout.landlord",
          count: 0,
          to: "/landlord"
        },
        {
          iconName: "mdi-city-variant",
          name: "layout.properties",
          count: 0,
          //to: "/properties"
        }
      ]
    };
  },
  apollo: {
    getAdminDashboard() {
      return {
        query: require("@/user/api/queries/admin_dashboard_query.graphql"),
        variables: {
          searchKey: ""
        },
        result({ data }) {
          // , loading, networkStatus, refetch
          this.adminDashbordData = data.getAdminDashboard;
          this.cards[0].count = this.adminDashbordData.totalCustomers;
          this.cards[1].count = this.adminDashbordData.totalLandlords;
          this.cards[2].count = this.adminDashbordData.totalProperties;
        }
      };
    }
  },
  methods: {
    // dashboradFilter (item) {
    //   switch (item) {
    //     case 'Active':
    //       this.cards[0].count = this.adminDashbordData.activeCustomers
    //       this.cards[1].count = this.adminDashbordData.activeLandlords
    //       this.cards[2].count = this.adminDashbordData.activeProperties
    //       break
    //     case 'In Active':
    //       this.cards[0].count = this.adminDashbordData.disabledCustomers
    //       this.cards[1].count = this.adminDashbordData.disabledLandlords
    //       this.cards[2].count = this.adminDashbordData.disabledProperties
    //       break
    //     case 'Total':
    //       this.cards[0].count = this.adminDashbordData.totalCustomers
    //       this.cards[1].count = this.adminDashbordData.totalLandlords
    //       this.cards[2].count = this.adminDashbordData.totalProperties
    //   }
    // }
  }
};
</script>
<style scoped>
.card-border {
  box-shadow: 2px 2px 9px rgba(146, 146, 146, 0.2) !important;
  border-radius: 15px;
}
.left-side-height {
  height: 100px;
}
</style>
